import { environment } from '@core/envs';
import { COUNTRY_CODE, COUNTRY_CODE_ISO_2, COUNTRY_CURRENCY, COUNTRY_LANG } from "@core/enums";
import { ICountry } from "../../interfaces/country/country-list.interface";

export const COUNTRY_LIST: ICountry[] = [
  {
    code: COUNTRY_CODE.ARGENTINA,
    language: COUNTRY_LANG.ARGENTINA,
    iso: COUNTRY_CODE_ISO_2.ARGENTINA,
    currency: COUNTRY_CURRENCY.ARGENTINA,
    hasDecimal: true,
    active: true,
  },
  {
    code: COUNTRY_CODE.BRAZIL,
    language: COUNTRY_LANG.BRAZIL,
    iso: COUNTRY_CODE_ISO_2.BRAZIL,
    currency: COUNTRY_CURRENCY.BRAZIL,
    hasDecimal: true,
     active: true,

  },
  {
    code: COUNTRY_CODE.CHILE,
    language: COUNTRY_LANG.CHILE,
    iso: COUNTRY_CODE_ISO_2.CHILE,
    currency: COUNTRY_CURRENCY.CHILE,
    hasDecimal: true,
    active: true,

  },
  {
    code: COUNTRY_CODE.COLOMBIA,
    language: COUNTRY_LANG.COLOMBIA,
    iso: COUNTRY_CODE_ISO_2.COLOMBIA,
    currency: COUNTRY_CURRENCY.COLOMBIA,
    hasDecimal: true,
    active: true,

  },
  {
    code: COUNTRY_CODE.ECUADOR,
    language: COUNTRY_LANG.ECUADOR,
    iso: COUNTRY_CODE_ISO_2.ECUADOR,
    currency: COUNTRY_CURRENCY.ECUADOR,
    hasDecimal: true,
    active: !environment.production
  },
  {
    code: COUNTRY_CODE.PERU,
    language: COUNTRY_LANG.PERU,
    iso: COUNTRY_CODE_ISO_2.PERU,
    currency: COUNTRY_CURRENCY.PERU,
    hasDecimal: true,
    active: true,
  },
  {
    code: COUNTRY_CODE.VENEZUELA,
    language: COUNTRY_LANG.VENEZUELA,
    iso: COUNTRY_CODE_ISO_2.VENEZUELA,
    currency: COUNTRY_CURRENCY.VENEZUELA,
    hasDecimal: true,
    active: !environment.production
  }
];
